import React from 'react';
import styled from 'styled-components';

import css from 'css';
import Html from 'partials/Html';

export default props => {
    const { title, children } = props;
    return (
        <Card>
            <h6>{title}</h6>
            <Html>{children}</Html>
        </Card>
    );
}

const Card = styled.div`
    max-width:470px;
    background: ${css.colors.lighterBrown};
    padding: 17px;
    position:relative;

    h6 {
        ${css.fonts.SSProSemiBold}
        font-size:20px;
        margin-bottom: 10px;
    }

    &:before {
        content: '';
        display: block;
        width: 100%;
        height: 90%;
        bottom: 0;
        left: -5px;
        background: #DCDCDC;
        transform: skew(3deg);
        position: absolute;
        z-index: -1;
    }
`




// WEBPACK FOOTER //
// ./src/partials/InfoCard.js